import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, AbstractControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormControlInit, DwFormFieldConfig,
         DwSectionBaseComponent } from '@devwareapps/devware-cap';

@DwComponent({
  key: 'dynamic-no-access',
  name: 'No Access (dynamic)',
  componentType: DwComponentType.formSection,
  isGlobal: true
})
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'app-dynamic-no-access',
    template: `
    <div [formGroup]="formGroup">
        <h1><i class="fad fa-user-lock fa-2x" style="--fa-secondary-color: red;"></i> You don't have permission to view this data or it does not exist</h1>
    </div>
  `,
})
export class DynamicNoAccessComponent  extends DwSectionBaseComponent {
    setupComponentComplete() { }
    initControl(): void { }
}
